export default class FileUpload {
    constructor() {
        this.uploadZones = document.querySelectorAll('[data-file-upload]');
        this.init();
    }

    init() {
        this.uploadZones.forEach(zone => {
            const input = zone.querySelector('.file-upload-input');
            const area = zone.querySelector('.file-upload-area');
            const listContainer = zone.querySelector('.file-upload-list');

            if (!input || !area || !listContainer) return;

            // Click to upload
            area.addEventListener('click', () => input.click());

            // File input change
            input.addEventListener('change', (e) => {
                // Don't manipulate input.files when using file picker
                // Just update the UI with the selected files
                this.updateFileList(e.target.files, listContainer, input);
            });

            // Drag & drop events
            area.addEventListener('dragover', (e) => {
                e.preventDefault();
                zone.classList.add('dragging');
            });

            area.addEventListener('dragleave', (e) => {
                e.preventDefault();
                if (e.target === area) {
                    zone.classList.remove('dragging');
                }
            });

            area.addEventListener('drop', (e) => {
                e.preventDefault();
                zone.classList.remove('dragging');

                const files = e.dataTransfer.files;
                this.handleFiles(files, zone, listContainer, input, true);
            });
        });
    }

    handleFiles(files, zone, listContainer, input, append = false) {
        if (!files || files.length === 0) return;

        // Create a new DataTransfer to hold our files
        const dataTransfer = new DataTransfer();

        // Add existing files only when appending (drag & drop)
        if (append && input.files) {
            Array.from(input.files).forEach(file => dataTransfer.items.add(file));
        }

        // Add new files
        Array.from(files).forEach(file => {
            if (this.validateFile(file, zone)) {
                dataTransfer.items.add(file);
            }
        });

        // Update input files
        input.files = dataTransfer.files;

        // Update UI
        this.updateFileList(dataTransfer.files, listContainer, input);
    }

    validateFile(file, zone) {
        const maxSize = 10 * 1024 * 1024; // 10MB
        const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

        if (file.size > maxSize) {
            this.showError('Datei ist zu groß. Maximale Größe: 10MB', zone);
            return false;
        }

        if (!allowedTypes.includes(file.type)) {
            this.showError('Ungültiges Dateiformat. Erlaubt: PDF, DOC, DOCX', zone);
            return false;
        }

        return true;
    }

    updateFileList(files, listContainer, input) {
        listContainer.innerHTML = '';

        Array.from(files).forEach((file, index) => {
            const item = this.createFileItem(file, index, listContainer, input);
            listContainer.appendChild(item);
        });
    }

    createFileItem(file, index, listContainer, input) {
        const item = document.createElement('div');
        item.className = 'file-upload-item';

        const info = document.createElement('div');
        info.className = 'file-upload-item-info';

        const icon = this.createFileIcon();
        const name = document.createElement('span');
        name.className = 'file-upload-item-name';
        name.textContent = file.name;

        const size = document.createElement('span');
        size.className = 'file-upload-item-size';
        size.textContent = this.formatFileSize(file.size);

        info.appendChild(icon);
        info.appendChild(name);
        info.appendChild(size);

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'file-upload-item-remove';
        removeBtn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>`;
        removeBtn.setAttribute('aria-label', 'Datei entfernen');

        removeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.removeFile(index, listContainer, input);
        });

        item.appendChild(info);
        item.appendChild(removeBtn);

        return item;
    }

    createFileIcon() {
        const svgNS = 'http://www.w3.org/2000/svg';
        const icon = document.createElementNS(svgNS, 'svg');
        icon.setAttribute('class', 'file-upload-item-icon');
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('fill', 'none');
        icon.setAttribute('stroke', 'currentColor');
        icon.setAttribute('stroke-width', '2');

        const path = document.createElementNS(svgNS, 'path');
        path.setAttribute('d', 'M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z');

        const polyline = document.createElementNS(svgNS, 'polyline');
        polyline.setAttribute('points', '13 2 13 9 20 9');

        icon.appendChild(path);
        icon.appendChild(polyline);

        return icon;
    }

    removeFile(index, listContainer, input) {
        const dataTransfer = new DataTransfer();

        Array.from(input.files).forEach((file, i) => {
            if (i !== index) {
                dataTransfer.items.add(file);
            }
        });

        input.files = dataTransfer.files;
        this.updateFileList(dataTransfer.files, listContainer, input);
    }

    formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    }

    showError(message, zone) {
        // You can implement a more sophisticated error display here
        const existingError = zone.querySelector('.file-upload-error');
        if (existingError) {
            existingError.remove();
        }

        const error = document.createElement('div');
        error.className = 'file-upload-error';
        error.textContent = message;
        error.style.color = 'var(--error, #f00)';
        error.style.fontSize = '0.875rem';
        error.style.marginTop = '8px';

        zone.appendChild(error);

        setTimeout(() => error.remove(), 5000);
    }
}
